<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="3"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center tw-mb-1">
						<p class="tw-text-app-color-primary text-lg">
							Agregar Conocimientos
						</p>
						<p-button
							type="primary"
							:disabled="knowledgeData.length > codeStep.maxKnowledge"
							@click="addKnowledge">
							Agregar Conocimientos
						</p-button>
					</div>
					<div class="info tw-flex tw-item-center tw-gap-x-6 tw-mb-3">
						<img src="/static/img/enter.svg" alt="">
						<p>Presionar enter para agregar conocimientos</p>
					</div>
					<section class="knowledge">
						<div class="text-uppercase knowledge-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-mb-4 tw-gap-x-32">
							<span>REQ.SELEC./CAP.</span>
							<span>CONOCIMIENTO</span>
						</div>
						<div class="knowledge-list">
							<table>
								<tr v-for="(knwledge, index) in knowledgeData" :key="index">
									<td class="req" tw-pr-1>
										<v-select
											class="select-core"
											hide-details
											:menu-props="{ contentClass: 'type-select-content' }"
											height="37"
											outline
											single-line
											:items="knowledges.data"
											placeholder="Seleccionar Tipo (Selec/Cap)"
											item-value="id"
											item-text="name"
											v-model="selectReq[index]"
											return-object
											@input="getKnowledge($event, index)"
										></v-select>
									</td>
									<td class="complement tw-pl-1">
										<input
											placeholder="Complemento"
											v-model="complements[index]"
											class="knowledge-list-input"
											@input="getComplement($event, index)"
											@keyup.enter="handleEnterKey">
									</td>
									<td>
										<app-tooltip-button
											img="/static/img/close2.svg"
											text="Eliminar"
											@click-icon="deleteKnowledge(index)"
										/>
									</td>
								</tr>
							</table>
						</div>
						<p-empty-message v-if="knowledgeData.length < 1">
							Agregar de 3 a 6 conocimientos<br>adquiridos
						</p-empty-message>
						<div>
							<p-horizontal-divider />
							<div class="tw-text-center">
								<p-button
									type="primary"
									@click="goTo(codeStep.returnTo)"
								>
									Atrás
								</p-button>
								<p-button
									type="secondary"
									:disabled="validateEmptyFields || knowledgeData.length < codeStep.minKnowledge || knowledgeData.length > codeStep.maxKnowledge"
									@click="saveStepthree"
								>
									Siguiente
								</p-button>
							</div>
						</div>
					</section>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'CONOCIMIENTOS REQUERIDOS'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Información adquirida a través de educación formal, eventos de capacitación o autoformación.
						</p>
						<div class="content-box">
							<table>
								<tr>
									<td style="width: 15%; vertical-align: top;"><p>Paso 1:</p></td>
									<td style="width: 85%">
										<p :style="`color:${$appColors.secondary}`">Escoge si es un requerimiento de selección o capacitación</p>
										<p><b>Requerimientos de Selección:</b> Antes de entregar el puesto se debe evaluar la destreza.</p>
										<p><b>Insumos de capacitación:</b> Antes de entregar el puesto se debe capacitar.</p>
									</td>
								</tr>
								<br>
								<tr>
									<td style="width: 15%; vertical-align: top;"><p>Paso 2:</p></td>
									<td style="width: 85%">
										<span :style="`color:${$appColors.secondary}`">Escríbe el conocimiento</span><br>
										<span :style="`color:${$appColors.primary}`">Analista de Operaciones.</span><br>
										<span><b>Conocimientos:</b></span><br>
										<span>Capacitado en Seguridad.</span><br>
										<span>Estadísticas</span><br>
										<span>Excel Intermedio</span>
									</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { path, pathOr } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	try {
		if (this.codeStep) {
			// ✅ USAR CACHE - Llamar al servicio centralizado con cache
			const response = await this.$store.dispatch('jobProfile/loadJobDescription', {
				codeStep: this.codeStep.code,
				jobId: this.selectedJob.id,
			});
			if (Object.keys(response).length !== 0) {
				this.knowledgeData = response.description;
				this.selectReq = response.description.map(item => item.req);
				this.complements = response.description.map(item => item.complement);
				this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function addKnowledge() {
	this.knowledgeData.push({
		req: {},
		complement: '',
	});
	if (this.knowledgeData.length > this.codeStep.maxKnowledge) {
		this.showNotification('Recuerda solo puedes agregar 6 Conocimientos', 'warning');
	}
	this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
}

function getKnowledge(knw, index) {
	this.selectReq[index] = knw;
	this.knowledgeData[index].req = this.selectReq[index];
	this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
}

function getComplement(comp, index) {
	this.complements[index] = comp.target.value;
	this.knowledgeData[index].complement = this.complements[index];
	this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
}

function handleEnterKey() {
	this.knowledgeData.push({
		req: {},
		complement: '',
	});
	this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
	if (this.knowledgeData > this.codeStep.maxKnowledge) {
		this.showGenericError('Recuerda solo puedes agregar 6 Conocimientos', 'warning');
	}
}

function deleteKnowledge(index) {
	this.knowledgeData.splice(index, 1);
	this.complements.splice(index, 1);
	this.selectReq.splice(index, 1);
	this.validateEmptyFields = this.knowledgeData.some(item => !item.req || !item.complement);
}

async function saveStepthree() {
	this.knowledgeData = this.knowledgeData.map((f) => {
		const newF = { ...f };
		newF.req = {
			id: f.req.id,
			name: f.req.name,
			code: f.req.code,
		};
		return newF;
	});
	const body = {
		description: this.knowledgeData,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);

		// ✅ INVALIDAR CACHE - Limpiar cache del job que se acaba de guardar
		this.$store.dispatch('jobProfile/clearJobDescriptionCache', this.selectedJob.id);

		this.showNotification('Conocimientos Requeridos Guardados Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		codeStep: {},
		knowledgeData: [],
		selectReq: [],
		complements: [],
		validateEmptyFields: true,
	};
}

export default {
	name: 'job-required-knowledge',
	data,
	beforeCreate() {
		// ✅ OPTIMIZADO: model-stepper ya carga la configuración
		// this.$store.dispatch('jobProfile/loadJobProfileConfig');
		this.$store.dispatch('jobProfile/loadKnowledges');
	},
	created() {},
	mounted() {},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	methods: {
		loadData,
		loadCodeStep,
		addKnowledge,
		getKnowledge,
		getComplement,
		handleEnterKey,
		deleteKnowledge,
		saveStepthree,
	},
	computed: {
		...mapState('jobProfile', {
			knowledges: path(['descriptionData', 'knowledge']),
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};

</script>

<style lang="scss" scoped>
.info {
	border: 1px solid color(border-gray) !important;
	background-color: color(gray-light) !important;
	border-radius: 50px;
	color: color(gray-sidebar);
	font-size: size(medium);
	height: 30px !important;
	padding: 2px 10px;
	width: 50%;
}
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: left;
		font-size: 12px;
	}
}
.knowledge {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	.knowledge-list {
		display: flex;
		bottom: 0;
		left: 0;
		padding: 0;
		position: relative !important;
		right: 0;
		table {
			width: 100%;
			.req {
				color: color(orange-light);
				font-size: size(large);
				padding-left: 10px;
				padding-top: 4px;
				width: 35%;
			}
			.complement {
				width: 70%;
			}
		}

		&-input {
			background: map-get($colors, white);
			border: 1px solid map-get($colors, gray-slider);
			border-radius: 4px;
			display: block;
			outline: none;
			color: color(gray-tabs) !important;
			margin-top: 4px;
			padding: 10px 20px;
			width: 100%;

			&::placeholder {
				color: map-get($colors, placeholder);
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/third-page/job-required-knowledge.vue